enum CellType {
  BOOLEAN = 'boolean',
  COORDINATE = 'coordinate',
  CURRENCY = 'currency',
  DATE_TIME = 'datetime',
  DOUBLE = 'double',
  INTEGER = 'integer',
  PERCENTAGE = 'percentage',
  STRING = 'string',
}

export default CellType;
